<app-preloader *ngIf="isLoading()"></app-preloader>
<app-notifications></app-notifications>
<form action="" [formGroup]="formGroup" novalidate>
  <!-- <button style="width: 100px;" (click)="status(formGroup)">Estado</button> -->

  <!-- Nombre y RoRAC -->
  <div class="nameAndRoRAC">
    <!-- Si se está editando un seguro incluir la clase "insurance" en el div.name -->
    <div class="inputWrapper name">
      <label for="">Nombre <span class="required">*</span></label>
      <input name="dealName" id="dealName" formControlName="dealName" data-select-id="dealName" dataSelectId />
    </div>
    <div class="inputWrapper rorac">
      <label for="">RoRAC</label>

      <div>
        <input
          type="number"
          name="roRac"
          id="roRac"
          formControlName="roRac"
          (keypress)="preventInvalidCharacters($event)"
        />
        <span>%</span>
      </div>
    </div>
  </div>

  @if (featureLoyaltyFeriaQuotation && !customerFeriaForLoyaltyUi()) {
    <div class="loyaltyDealCheck nameAndRoRAC" aria-label="Loyalty por propuesta">
      <label class="checkboxWrapper" for="openDealLoyaltyMob">
        <input type="checkbox" id="openDealLoyaltyMob" formControlName="dealIsLoyalty" />
        <span class="checkmark"></span>
        <span class="description">Propuesta Loyalty</span>
        <span class="loyaltyBadge" aria-hidden="true"><img src="./assets/images/icons/loyalty.svg" alt="" /></span>
      </label>
    </div>
  }

  <!-- Información contractual -->
  <div class="contractMobileEdition" id="contract-edition">
    <div class="titleWrapper">
      <h4>Información contractual</h4>
      <a class="accordionControl" (click)="collapse()" style="cursor: pointer"></a>
    </div>
    <div class="accordionWrapper">
      <div>
        <div class="mainWrapper">
          <!-- Parámetros -->
          <div class="parameters">
            <div class="general">
              <!-- Producto financiero -->
              <div class="row">
                <label>{{ 'Financial product' | translate }}<span class="required">*</span></label>
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select
                      formControlName="financialProductType"
                      data-select-id="financialProductType"
                      dataSelectId
                      (change)="selectFinacialProduct()"
                    >
                      @for (product of financialProductList(); track product.value) {
                        <option [value]="product.value">
                          {{ product.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>

              <!-- Plazo -->
              <div class="row">
                <label>{{ 'Term' | translate }} <span class="required">*</span></label>
                <div class="wrapperS4">
                  <input
                    type="number"
                    formControlName="term"
                    class="size0 textAlignRight gapRight"
                    (keypress)="preventInvalidCharacters($event)"
                    (blur)="onChangeTerm()"
                    data-select-id="term"
                    dataSelectId
                    appInputValidations
                    [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                    [maxValue]="ConstantsComp.MAX_TERMS_FOR_SPECIAL_PRODUCT"
                  />
                  <span>{{ term }}</span>
                </div>
              </div>

              <!-- Segmento OPEX -->
              <div class="row">
                <label>{{ 'OPEX Segment' | translate }}</label>
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select formControlName="opexSegment">
                      @for (segment of financialCalculator.segmentOpex; track segment.value) {
                        <option [value]="segment.value">
                          {{ segment.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>
              <!-- Moneda -->
              <div class="row">
                <label>{{ 'Currency' | translate }} <span class="required">*</span></label>
                <div class="selectWrapper gapRight">
                  <div class="customSelect size1">
                    <select formControlName="currencyType" (change)="onChangeCurrencyType()">
                      @for (currency of financialCalculator.currencies; track currency.value) {
                        <option [value]="currency.value">
                          {{ currency.type }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>

              <!-- Cotización -->
              <div class="row">
                <label>{{ 'USD Quote' | translate }}</label>
                <div>
                  <input
                    type="number"
                    formControlName="quoteUsd"
                    class="size1 textAlignRight gapRight"
                    (keypress)="preventInvalidCharacters($event)"
                    appInputValidations
                    [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                    [maxDecimals]="ConstantsComp.MAX_DECIMALS_FOR_NUMBERS"
                    [maxValue]="ConstantsComp.MAX_VALUE_FOR_NUMBERS"
                  />
                  <span>MXN</span>
                </div>
              </div>

              <!-- IVA -->
              <div class="row">
                <label>{{ 'VAT' | translate }}</label>
                <div class="wrapperS2">
                  <input
                    type="number"
                    class="size0 percentage textAlignRight gapRight"
                    formControlName="tax"
                    (blur)="calculateUnitPriceWithTax('unitPriceWithTax')"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="tax"
                    dataSelectId
                    appInputValidations
                  />
                  <span>%</span>
                </div>
              </div>

              <!-- Exento IVA -->
              <div class="row">
                <label>{{ 'VAT exempt' | translate }} <span class="required">*</span></label>
                <div>
                  @if (noVatExemptVisible) {
                    <span>NO</span>
                  } @else {
                    <div class="wrapperS4">
                      <div class="selectWrapper size0">
                        <div class="customSelect">
                          <select formControlName="taxFree" (change)="calculateFinacialAmountUpdate()">
                            @for (option of taxFreeOptions; track option.value) {
                              <option [value]="option.value">
                                {{ option.display }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

              <!-- Tasa al cliente -->
              <div class="row">
                <label>{{ 'Customer Rate' | translate }} <span class="required">*</span></label>
                <div class="wrapperS2">
                  <input
                    type="number"
                    formControlName="customerRate"
                    class="size0 percentage textAlignRight"
                    (blur)="onlyChangeValue()"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="customerRate"
                    dataSelectId
                    appInputValidations
                  />
                  <span>%</span>
                </div>
              </div>
            </div>

            <div class="vehicle">
              <!-- Photo -->
              <div class="photo">
                <div class="wrapper">
                  @if (showImg) {
                    <!-- Si tiene imagen mostrar picture-->
                    <picture>
                      <!-- Incluir la imagen que corresponda-->
                      <img [src]="imageSB" alt="Marca Submarca" />
                    </picture>
                  } @else {
                    <!-- Si no tiene imagen mostrar div.noImage-->
                    <div class="noImage">
                      <span>{{ 'No image' | translate }}</span>
                    </div>
                  }
                </div>
              </div>

              <!-- Tipo de poducto -->
              <div class="row">
                <label>Tipo de producto <span class="required">*</span></label>
                <div class="selectWrapper">
                  <div class="customSelect">
                    <select
                      formControlName="productType"
                      data-select-id="productType"
                      dataSelectId
                      (change)="selectProduct()"
                    >
                      <option [value]="null" hidden selected>Seleccione un tipo de producto</option>
                      @for (product of financialCalculator.productType; track product.value) {
                        <option [value]="product.value" *ngIf="product.isValidToSelect(!isActiveBrokerCatalog)">
                          {{ product.name }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              </div>

              <!-- Check modelo de catálogo-->
              <div>
                <label
                  class="checkboxWrapper"
                  for="modeloCatalogoMobile"
                  data-select-id="includesInsurance"
                  dataSelectId
                >
                  <input
                    type="checkbox"
                    id="modeloCatalogoMobile"
                    formControlName="includesInsurance"
                    (change)="onChangeIncludesInsurance($event)"
                  />
                  <span class="checkmark"></span>
                  <span class="description">Modelo de catálogo con opción de seguro Broker</span>
                </label>
              </div>

              <!-- Opciones para modelo de catálogo -->
              @if (isActiveBrokerCatalog) {
                <div class="catalog">
                  <!-- Condición -->
                  <div class="row">
                    <label>{{ 'Condition' | translate }}</label>
                    @if (isAccesoriesProduct && isActiveAccesoriesMarsh) {
                      <span>{{ getClassificationOptions() | translate }}</span>
                    } @else {
                      <div class="selectWrapper">
                        <div class="customSelect">
                          <select
                            formControlName="classification"
                            data-select-id="classification"
                            dataSelectId
                            (change)="onChangeClassification()"
                            tabindex="14"
                          >
                            @for (option of classificationOptions; track option.value) {
                              <option [value]="option.value" *ngIf="option.isValidToSelect(isActiveBrokerCatalog)">
                                {{ option.display | translate }}
                              </option>
                            }
                          </select>
                        </div>
                      </div>
                    }
                  </div>

                  <!-- Tiempo de uso -->
                  <!-- Mostrar si la condición es "Usado"-->
                  @if (isUsedClassification) {
                    <div class="row">
                      <label>{{ 'Usage Time' | translate }} <span class="required">*</span></label>
                      <div class="wrapperS4">
                        <input
                          type="number"
                          formControlName="useTime"
                          class="size0 textAlignRight gapRight"
                          (blur)="onCHnageUseTime()"
                          appInputValidations
                          [maxValue]="ConstantsComp.MAX_USE_TIME_FOR_PRODUCTS"
                          [minValue]="ConstantsComp.MIN_USE_TIME_FOR_PRODUCTS"
                          [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                        />
                        <span>{{ 'Months' | translate }}</span>
                      </div>
                    </div>
                  }

                  <!-- Año -->
                  <div class="row">
                    <label>Año <span class="required">*</span></label>
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select formControlName="year" data-select-id="year" dataSelectId (change)="changeYear($event)">
                          <option [value]="null" disabled hidden selected>Seleccione un año</option>
                          @for (year of yearsListByProduct(); track year) {
                            <option [value]="year.value" [hidden]="year.value === null">
                              {{ year.name }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <!-- Modelo -->
                  <div class="row">
                    <label>{{ 'Model' | translate }} <span class="required">*</span></label>
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select
                          formControlName="modelId"
                          data-select-id="modelId"
                          dataSelectId
                          (change)="changeModel($event)"
                        >
                          <option [value]="null" hidden selected>Buscar modelo</option>
                          @for (product of productListFiltered(); track product.modelCode) {
                            <option [value]="product.id" [disabled]="!product.enabled">
                              {{ getModelNameWithCode(product) }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Cantidad -->
                  <div class="row">
                    <label>Cantidad <span class="required">*</span></label>
                    <input
                      type="number"
                      formControlName="quantity"
                      (blur)="changeQuantity()"
                      class="size0 textAlignRight gapRight"
                      data-select-id="quantity"
                      dataSelectId
                      appInputValidations
                      [maxValue]="ConstantsComp.MAX_QUANTITY_FOR_NORMAL_PRODUCT"
                      [minValue]="ConstantsComp.MIN_QUANTITY_FOR_NORMAL_PRODUCT"
                      [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                    />
                  </div>

                  <!-- Marca -->
                  @if (!isAccesoriesProduct && isActiveAccesoriesMarsh) {
                    <div class="row">
                      <label>{{ 'Brand' | translate }}</label>
                      <div>
                        <span>{{ modelBrandName }}</span>
                      </div>
                    </div>
                  }

                  <!-- Submarca -->
                  <div class="row">
                    <label>{{
                      (isAccesoriesProduct && isActiveAccesoriesMarsh ? 'Model' : 'Sub-brand') | translate
                    }}</label>
                    <div>
                      <span>{{ modelSubBrandName }}</span>
                    </div>
                  </div>
                </div>
              } @else {
                <!-- Opciones para modelo fuera de catálogo -->
                <div class="noCatalog">
                  <!-- Marca -->
                  @if (!isAccesoriesProduct || !isActiveAccesoriesMarsh) {
                    <div class="row">
                      <label>{{ 'Brand' | translate }}</label>
                      <div class="selectWrapper">
                        <div class="selectWrapper">
                          <div class="customSelect">
                            <select
                              formControlName="brandId"
                              (change)="onBrandChange($event)"
                              data-select-id="brandId"
                              dataSelectId
                            >
                              @if (brands && brands.length < 1) {
                                <option [value]="null" selected hidden>Sin Marca disponible</option>
                              } @else {
                                <option [value]="null" hidden>Seleccione una marca</option>
                                @for (brand of brands; track brand.id) {
                                  <option [value]="brand.id">
                                    {{ brand.name }}
                                  </option>
                                }
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Submarca -->
                  <div class="row">
                    <label>{{
                      (isAccesoriesProduct && isActiveAccesoriesMarsh ? 'Model' : 'Sub-brand') | translate
                    }}</label>
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select
                          formControlName="subBrandId"
                          (change)="onSubBrandChange($event)"
                          data-select-id="subBrandId"
                          dataSelectId
                        >
                          @if (subBrands && subBrands.length < 1) {
                            <option [value]="null" selected hidden>Sin Submarcas Disponibles</option>
                          } @else {
                            <option [value]="null" hidden>Seleccione una submarca</option>
                            @for (sub of subBrands; track sub.id) {
                              <option [value]="sub.id">
                                {{ sub.name }}
                              </option>
                            }
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Condición -->
                  <div class="row">
                    <label>Condición</label>
                    <div class="selectWrapper">
                      <div class="customSelect">
                        <select formControlName="classification" (change)="onChangeClassification()">
                          @for (option of classificationOptions; track option.value) {
                            <option [value]="option.value" *ngIf="option.isValidToSelect(isActiveBrokerCatalog)">
                              {{ option.display | translate }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Tiempo de uso -->
                  <!-- Mostrar si la condición es "Usado"-->
                  @if (isUsedClassification) {
                    <div class="row">
                      <label>{{ 'Usage Time' | translate }} <span class="required">*</span></label>
                      <div class="wrapperS4">
                        <input
                          type="number"
                          formControlName="useTime"
                          class="size0 textAlignRight gapRight"
                          (blur)="onlyChangeValue()"
                          appInputValidations
                          [maxValue]="ConstantsComp.MAX_USE_TIME_FOR_PRODUCTS"
                          [minValue]="ConstantsComp.MIN_USE_TIME_FOR_PRODUCTS"
                          [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                        />
                        <span>{{ 'Months' | translate }}</span>
                      </div>
                    </div>
                  }

                  <!-- Cantidad -->
                  <div class="row">
                    <label>Cantidad <span class="required">*</span></label>
                    <input
                      type="number"
                      formControlName="quantity"
                      (blur)="changeQuantity()"
                      class="size0 textAlignRight gapRight"
                      data-select-id="quantity"
                      dataSelectId
                      appInputValidations
                      [maxValue]="ConstantsComp.MAX_QUANTITY_FOR_NORMAL_PRODUCT"
                      [minValue]="ConstantsComp.MIN_QUANTITY_FOR_NORMAL_PRODUCT"
                      [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                    />
                  </div>

                  <!-- Caracteristicas -->
                  <div class="row group">
                    <div class="innerRow">
                      <label>{{ 'Characteristics' | translate }}</label>
                    </div>
                    <div class="innerRow">
                      <textarea cols="30" rows="10" formControlName="feature"></textarea>
                    </div>
                  </div>
                </div>
              }
            </div>

            <div class="conditions">
              <!-- Precio unitario -->
              <div class="row group">
                <label>Precio unitario <span class="required">*</span></label>
                <div class="innerRow">
                  <label class="note">Sin IVA</label>
                  <div>
                    <input
                      type="number"
                      id="unitPriceWithoutTax"
                      class="amount xl gapRight"
                      style="display: none"
                      formControlName="unitPriceWithoutTax"
                      (blur)="calculateUnitPriceWithoutTax('unitPriceWithoutTax')"
                      (keypress)="preventInvalidCharacters($event)"
                    />
                    <input
                      data-select-id="unitPriceWithoutTax"
                      dataSelectId
                      type="text"
                      id="hidden-unitPriceWithoutTax"
                      class="amount xl gapRight"
                      (focus)="showAmountInput('unitPriceWithoutTax')"
                      style="display: block"
                      [value]="ctr['unitPriceWithoutTax'].value | currency: '' : ''"
                    />
                    <span>{{ currencySelected() }}</span>
                  </div>
                </div>

                <div class="innerRow">
                  <label class="note">Con IVA</label>
                  <div>
                    <input
                      type="number"
                      id="unitPriceWithTax"
                      class="amount xl gapRight"
                      style="display: none"
                      formControlName="unitPriceWithTax"
                      (blur)="calculateUnitPriceWithTax('unitPriceWithTax')"
                      (keypress)="preventInvalidCharacters($event)"
                    />
                    <input
                      type="text"
                      id="hidden-unitPriceWithTax"
                      data-select-id="unitPriceWithTax"
                      dataSelectId
                      class="amount xl gapRight"
                      (focus)="showAmountInput('unitPriceWithTax')"
                      style="display: block"
                      [value]="ctr['unitPriceWithTax'].value | currency: '' : ''"
                    />
                    <span>{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Total venta -->
              <div class="row group">
                <label>Total venta</label>
                <div class="innerRow">
                  <label class="note" *ngIf="ctr['totalPriceWithoutTax'].value">Sin IVA</label>
                  <div>
                    <span class="amountReadOnly xl gapRight">{{
                      ctr['totalPriceWithoutTax'].value ? (ctr['totalPriceWithoutTax'].value | currency: '' : '') : ''
                    }}</span>
                    <span *ngIf="ctr['totalPriceWithoutTax'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
                <div class="innerRow">
                  <label class="note gapRight" *ngIf="ctr['totalPriceWithTax'].value">Con IVA</label>
                  <div>
                    <span class="amountReadOnly xl gapRight">{{
                      ctr['totalPriceWithTax'].value ? (ctr['totalPriceWithTax'].value | currency: '' : '') : ''
                    }}</span>
                    <span *ngIf="ctr['totalPriceWithTax'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Enganche -->
              <div class="row group" *ngIf="isViewDownPayment">
                <div class="innerRow">
                  <label>Enganche <span class="required">*</span></label>
                  <div class="selectWrapper size2 gapRight">
                    <div class="customSelect">
                      <select formControlName="downPaymentTaxType" (change)="calculateDownPayment()">
                        @for (taxType of taxTypeDownPaymentOptions; track taxType) {
                          <option
                            *ngIf="taxType.isValidToSelect(ctr['financialProductType'].value)"
                            [value]="taxType.value"
                          >
                            {{ taxType.display }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <div class="innerRow">
                  <label></label>
                  <div class="innerWrapper">
                    <ng-container *ngIf="ctr['downPaymentTaxType'].value">
                      <ng-container *ngIf="isDownPaymentTypeVariable">
                        <input
                          type="number"
                          formControlName="downPaymentTax"
                          (blur)="calculateDownPayment()"
                          class="size0 percentage textAlignRight gapRight"
                          (keypress)="preventInvalidCharacters($event)"
                          appInputValidations
                        />
                      </ng-container>
                      <span *ngIf="isDownPaymentTypeVariable">%</span>
                    </ng-container>
                  </div>
                </div>
                <div class="innerRow">
                  <label></label>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      id="downPayment"
                      class="amount gapRight"
                      style="display: none"
                      (blur)="calculateDownPayment('downPayment')"
                      (keypress)="preventInvalidCharacters($event)"
                      formControlName="downPayment"
                      appInputValidations
                      [maxValue]="maxDownPaymentValue"
                      [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                      [maxDecimals]="ConstantsComp.MAX_DECIMALS_FOR_NUMBERS"
                      class="amount gapRight"
                      (focus)="showAmountInput('downPayment')"
                      [disabled]="isDownPaymentTypeVariable"
                      style="display: block"
                      [value]="ctr['downPayment'].value | currency: '' : ''"
                    />
                    <span *ngIf="ctr['downPayment'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Monto a financiar -->
              <div class="row">
                <label>Monto a financiar</label>
                <div class="wrapperSX flexEnd">
                  <span class="amountReadOnly xl gapRight">{{
                    ctr['financialAmount'].value ? (ctr['financialAmount'].value | currency: '' : '') : ''
                  }}</span>
                  <span *ngIf="ctr['financialAmount'].value">{{ currencySelected() }}</span>
                </div>
              </div>

              <!-- Comisión por apertura -->
              <div class="row group">
                <div class="innerRow">
                  <label>Comisión por apertura. <span class="required">*</span></label>
                  <div class="wrapperS4">
                    <input
                      type="number"
                      formControlName="openingFeePercentage"
                      (blur)="calculateCommissionForOpening()"
                      class="size0 percentage textAlignRight gapRight"
                      (keypress)="preventInvalidCharacters($event)"
                      required
                      appInputValidations
                    />
                    <span *ngIf="isOpeningFeeTypeVariable">%</span>
                  </div>
                </div>

                <div class="innerRow">
                  <label class="note">Sin IVA</label>
                  <div class="wrapperS2">
                    <span class="amountReadOnly xl gapRight">{{
                      ctr['openingFeeWithoutTax'].value ? (ctr['openingFeeWithoutTax'].value | currency: '' : '') : ''
                    }}</span>
                    <span *ngIf="ctr['openingFeeWithoutTax'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
                <div class="innerRow">
                  <label class="note">Con IVA</label>
                  <div>
                    <span class="amountReadOnly xl gapRight">{{
                      ctr['openingFeeWithTax'].value ? (ctr['openingFeeWithTax'].value | currency: '' : '') : ''
                    }}</span>
                    <span *ngIf="ctr['openingFeeWithTax'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Depósitos en garantía -->
              <div class="row group">
                <div class="innerRow">
                  <label>Depósitos en garantía </label>
                  <!-- Opciones tipo de depósito -->
                  <div class="selectWrapper size2 gapRight">
                    <div class="customSelect">
                      <select
                        formControlName="warrantyDeposit"
                        (change)="onChangeWarrantyDepositSelectorValue('warrantyDeposit')"
                      >
                        @for (taxType of taxTypeWarrantyOptions; track taxType) {
                          <option
                            *ngIf="taxType.isValidToSelect(ctr['financialProductType'].value)"
                            [value]="taxType.value"
                          >
                            {{ taxType.display }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>
                <ng-container *ngIf="ctr['warrantyDeposit'].value">
                  <div class="innerRow">
                    <label></label>
                    <div>
                      <ng-container *ngIf="isWarrantyDepositNotFixedOrRentBased">
                        <input
                          type="number"
                          formControlName="warrantyDepositPercentage"
                          (blur)="onChangeWarrantyDepositValue()"
                          class="size0 percentage textAlignRight gapRight"
                          (keypress)="preventInvalidCharacters($event)"
                          appInputValidations
                        />
                      </ng-container>

                      <ng-container *ngIf="isWarrantyDepositRentBased">
                        <input
                          type="number"
                          formControlName="warrantyDepositMonth"
                          (blur)="onChangeWarrantyDepositValue()"
                          class="size0 textAlignRight gapRight"
                          (keypress)="preventInvalidCharacters($event)"
                          appInputValidations
                          [maxValue]="ctr['term'].value"
                          [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                          [maxDecimals]="ConstantsComp.NOT_DECIMALS"
                        />
                      </ng-container>

                      <span *ngIf="isWarrantyDepositNotFixedOrRentBased">%</span>
                    </div>
                  </div>
                </ng-container>

                <div class="innerRow">
                  <label></label>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      id="warrantyDepositTotal"
                      class="amount gapRight"
                      style="display: none"
                      (blur)="onlyChangeValue('warrantyDepositTotal')"
                      formControlName="warrantyDepositTotal"
                      (keypress)="preventInvalidCharacters($event)"
                      appInputValidations
                      [maxValue]="ctr['unitPriceWithTax'].value"
                      [minValue]="ConstantsComp.MIN_NUMBER_FOR_NOT_DECIMALS"
                      [maxDecimals]="ConstantsComp.MAX_DECIMALS_FOR_NUMBERS"
                    />
                    <input
                      *ngIf="warrantyDepositViewTotal"
                      type="text"
                      id="hidden-warrantyDepositTotal"
                      class="amount gapRight"
                      (focus)="showAmountInput('warrantyDepositTotal')"
                      [disabled]="isWarrantyDepositNotFixedAmount"
                      style="display: block"
                      [value]="ctr['warrantyDepositTotal'].value | currency: '' : ''"
                    />
                    <span *ngIf="ctr['warrantyDepositTotal'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>

              <!-- Subsidio -->
              <div class="row group">
                <div class="innerRow">
                  <label>Subsidio</label>
                  <div class="selectWrapper size2 gapRight">
                    <div class="customSelect">
                      <select
                        formControlName="subsidyType"
                        (change)="changeSubsidy('subsidyTotalWithTax')"
                        data-select-id="subsidyType"
                        dataSelectId
                      >
                        @for (option of subsidyTypeOptions; track option) {
                          <option [value]="option.value">
                            @if (option.percentage) {
                              %
                            }
                            {{ option.display | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                <div class="innerRow" *ngIf="isSubsidyTypeNotNull && isSubsidyTypeNotFixedAmount">
                  <label></label>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      formControlName="subsidyPercentage"
                      (blur)="changeSubsidy('subsidyTotalWithTax')"
                      class="size0 percentage textAlignRight"
                      (keypress)="preventInvalidCharacters($event)"
                      data-select-id="subsidyPercentage"
                      dataSelectId
                      appInputValidations
                    />
                    <span *ngIf="isSubsidyTypeNotFixedAmount">%</span>
                  </div>
                </div>
                <div class="innerRow" *ngIf="isSubsidyTypeNotEmpty && !isSubsidyTypeNotFixedAmount">
                  <label></label>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      id="subsidyTotal"
                      class="amount gapRight"
                      style="display: none"
                      (blur)="changeSubsidy('subsidyTotalWithTax', 'subsidyTotal')"
                      formControlName="subsidyTotal"
                      (keypress)="preventInvalidCharacters($event)"
                    />
                    <input
                      type="text"
                      id="hidden-subsidyTotal"
                      class="amount gapRight"
                      (focus)="showAmountInput('subsidyTotal')"
                      [disabled]="isSubsidyTypeNotFixedAmount"
                      style="display: block"
                      [style]="subsidyTotalWithoutTaxStyle"
                      [value]="ctr['subsidyTotal'].value | currency: '' : ''"
                    />
                    @if (ctr['subsidyTotal'].value) {
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                </div>

                <div class="innerRow" *ngIf="isSubsidyTypeNotEmpty && isSubsidyTypeNotFixedAmount">
                  <label class="note">{{ 'Excluding VAT' | translate }}</label>
                  <div class="wrapperS2">
                    @if (getAutoFieldSubsidyTotal('withoutTax'); as valueWithoutTax) {
                      <span class="amountReadOnly xl gapRight" [style]="subsidyTotalWithoutTaxStyle">{{
                        valueWithoutTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                </div>
                <div class="innerRow" *ngIf="isSubsidyTypeNotEmpty && isSubsidyTypeNotFixedAmount">
                  <label class="note">{{ 'Including VAT' | translate }}</label>
                  <div class="wrapperS2">
                    @if (getAutoFieldSubsidyTotal('withTax'); as valueWithTax) {
                      <span class="amountReadOnly xl gapRight" [style]="subsidyTotalWithTaxStyle">{{
                        valueWithTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                </div>
              </div>

              <!-- Ballon -->
              <div class="row group" *ngIf="hasBallonFields && isActiveBallon">
                <div class="innerRow">
                  <label>Balloon</label>
                  <div class="selectWrapper size2 gapRight">
                    <div class="customSelect">
                      <select
                        formControlName="balloonType"
                        (change)="changeBalloon('balloonTotalWithTax')"
                        data-select-id="balloonType"
                        dataSelectId
                        tabindex="37"
                      >
                        @for (taxType of taxTypeBalloonOptions; track taxType) {
                          <option
                            *ngIf="taxType.isValidToSelect(ctr['financialProductType'].value)"
                            [ngValue]="taxType.value"
                          >
                            {{ taxType.display }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                <div class="innerRow" *ngIf="isBallonTypeNotNull && !isBallonTypeFixedAmount">
                  <label></label>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      formControlName="balloonPercentage"
                      (change)="changeBalloon('balloonTotalWithTax')"
                      class="size0 textAlignRight"
                      (keypress)="preventInvalidCharacters($event)"
                      data-select-id="subsidyPercentage"
                      dataSelectId
                      appInputValidations
                    />
                    <span>%</span>
                  </div>
                </div>
                <div class="innerRow" *ngIf="isBallonTypeNotNull && isBallonTypeFixedAmount">
                  <label></label>
                  <div class="innerWrapper">
                    <input
                      type="number"
                      id="balloon"
                      class="amount gapRight"
                      style="display: none"
                      (blur)="changeBalloon('balloonTotalWithTax', 'balloon')"
                      formControlName="balloon"
                      (keypress)="preventInvalidCharacters($event)"
                      data-select-id="balloon"
                      dataSelectId
                    />
                    <input
                      type="text"
                      id="hidden-subsidyTotal"
                      class="amount gapRight"
                      (focus)="showAmountInput('balloon')"
                      [disabled]="!isBallonTypeFixedAmount"
                      [style]="balloonTotalWithoutTaxStyle"
                      style="display: block"
                      [value]="ctr['balloon'].value | currency: '' : ''"
                    />
                    @if (ctr['balloon'].value) {
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                </div>

                <div class="innerRow" *ngIf="isBalloonTypeNotEmpty && !isBallonTypeFixedAmount">
                  <label class="note">{{ 'Excluding VAT' | translate }}</label>
                  <div class="wrapperS2">
                    @if (getAutoFieldBalloonTotal('withoutTax'); as valueWithoutTax) {
                      <span class="amountReadOnly xl gapRight" [style]="subsidyTotalWithoutTaxStyle">{{
                        valueWithoutTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                </div>
                <div class="innerRow" *ngIf="isBalloonTypeNotEmpty && !isBallonTypeFixedAmount">
                  <label class="note">{{ 'Including VAT' | translate }}</label>
                  <div class="wrapperS2">
                    @if (getAutoFieldBalloonTotal('withTax'); as valueWithTax) {
                      <span class="amountReadOnly xl gapRight" [style]="subsidyTotalWithTaxStyle">{{
                        valueWithTax | currency: '' : ''
                      }}</span>
                      <span>{{ currencySelected() }}</span>
                    }
                  </div>
                </div>
              </div>

              <!-- Valor residual -->
              <div class="row group" *ngIf="isFinancialProductTypePureLease">
                <div class="innerRow">
                  <label>Valor residual <span class="required">*</span></label>

                  <div class="selectWrapper size2 gapRight">
                    <div class="customSelect">
                      <select
                        formControlName="residualValueType"
                        (change)="changeResidualValue('residualValueTotal')"
                        data-select-id="residualValueType"
                        dataSelectId
                      >
                        @for (option of residualValueTypeOptions; track option) {
                          <option [value]="option.value" [hidden]="option?.hidden">
                            @if (option.percentage) {
                              %
                            }
                            {{ option.display | translate }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                </div>

                @if (isResidualValueTypeNotNull && isResidualValueTypeNotFixedAmount) {
                  <div class="innerRow">
                    <label></label>
                    <div class="innerWrapper">
                      <input
                        *ngIf="ctr['residualValueType'].value != taxType.fixedAmount"
                        type="number"
                        formControlName="residualValuePercentage"
                        class="size0 percentage textAlignRight"
                        (blur)="changeResidualValue('residualValueTotal')"
                        (keypress)="preventInvalidCharacters($event)"
                        data-select-id="residualValuePercentage"
                        dataSelectId
                        appInputValidations
                      />
                      <span *ngIf="ctr['residualValueType'].value != taxType.fixedAmount">%</span>
                    </div>
                  </div>
                }
                @if (isResidualValueTypeNotNull && !isResidualValueTypeNotFixedAmount) {
                  <div class="innerRow">
                    <label></label>
                    <div class="innerWrapper">
                      <input
                        type="number"
                        id="residualValueTotal"
                        class="amount gapRight"
                        style="display: none"
                        (blur)="changeResidualValue('residualValueTotal', 'residualValueTotal')"
                        formControlName="residualValueTotal"
                        (keypress)="preventInvalidCharacters($event)"
                      />
                      <input
                        type="text"
                        id="hidden-residualValueTotal"
                        class="amount gapRight"
                        (focus)="showAmountInput('residualValueTotal')"
                        [disabled]="isResidualValueTypeNotFixedAmount"
                        style="display: block"
                        [style]="residualValueTotalWithoutTaxStyle"
                        [value]="ctr['residualValueTotal'].value | currency: '' : ''"
                      />
                      @if (ctr['residualValueTotal'].value) {
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                }
                @if (isResidualValueTypeNotNull && isResidualValueTypeNotFixedAmount) {
                  <div class="innerRow">
                    <label class="note">{{ 'Excluding VAT' | translate }}</label>
                    <div class="wrapperS2">
                      @if (getAutoFieldResidualValueTotal('withoutTax'); as valueWithoutTax) {
                        <span class="amountReadOnly xl gapRight" [style]="residualValueTotalWithoutTaxStyle">{{
                          valueWithoutTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                }
                @if (isResidualValueTypeNotNull && isResidualValueTypeNotFixedAmount) {
                  <div class="innerRow">
                    <label class="note">{{ 'Including VAT' | translate }}</label>
                    <div class="wrapperS2">
                      @if (getAutoFieldResidualValueTotal('withTax'); as valueWithTax) {
                        <span class="amountReadOnly xl gapRight" [style]="residualValueTotalWithTaxStyle">{{
                          valueWithTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                }
              </div>

              <!-- Opción de compra -->
              <div class="row group" *ngIf="isFinancialProductTypeFinancialLeasing">
                <div class="innerRow">
                  <label>Valor residual <span class="required">*</span></label>
                  <div class="selectWrapper size2 gapRight">
                    <div class="customSelect">
                      <select
                        formControlName="purchaseOptionType"
                        (change)="changePurchaseOption('purchaseTotalWithTax')"
                        data-select-id="purchaseOptionType"
                        dataSelectId
                      >
                        <option [value]="taxType.invoiceWithTax">% {{ 'valueIncludingVAT' | translate }}</option>
                        <option [value]="taxType.invoiceWithoutTax">% {{ 'valueExcludeVAT' | translate }}</option>
                        <option [value]="taxType.amountToFinance">% {{ 'Amount to Finance' | translate }}</option>
                        <option [value]="taxType.fixedAmount">{{ 'Fixed Amount' | translate }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                @if (isPurchaseOptionTypeNotNull && isPurchaseOptionTypeNotFixedAmount) {
                  <div class="innerRow">
                    <label></label>
                    <div class="innerWrapper">
                      <input
                        type="number"
                        formControlName="purchasePercentage"
                        (blur)="changePurchaseOption('purchaseTotalWithTax')"
                        class="size0 percentage textAlignRight"
                        (keypress)="preventInvalidCharacters($event)"
                        data-select-id="purchasePercentage"
                        dataSelectId
                        appInputValidations
                      />
                      <span *ngIf="isPurchaseOptionTypeNotFixedAmount">%</span>
                    </div>
                  </div>
                }
                @if (isPurchaseOptionTypeNotNull && !isPurchaseOptionTypeNotFixedAmount) {
                  <div class="innerRow">
                    <label></label>
                    <div class="innerWrapper">
                      <input
                        type="number"
                        id="purchaseTotal"
                        class="amount gapRight"
                        style="display: none"
                        (blur)="changePurchaseOption('purchaseTotalWithTax', 'purchaseTotal')"
                        (keypress)="preventInvalidCharacters($event)"
                        formControlName="purchaseTotal"
                        tabindex="45"
                      />
                      <input
                        type="text"
                        id="hidden-purchaseTotal"
                        class="amount gapRight"
                        (focus)="showAmountInput('purchaseTotal')"
                        [disabled]="isPurchaseOptionTypeNotFixedAmount"
                        [style]="purchaseTotalWithoutTaxStyle"
                        style="display: block"
                        [value]="ctr['purchaseTotal'].value | currency: '' : ''"
                        tabindex="45"
                      />
                      @if (ctr['purchaseTotal'].value) {
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                }
                @if (isPurchaseOptionTypeNotNull) {
                  <div class="innerRow">
                    <label class="note">{{ 'Excluding VAT' | translate }}</label>
                    <div class="wrapperS2">
                      @if (getAutoFieldPurchaseTotal('withoutTax'); as valueWithoutTax) {
                        <span class="amountReadOnly xl gapRight" [style]="purchaseTotalWithoutTaxStyle">{{
                          valueWithoutTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                }
                @if (isPurchaseOptionTypeNotNull) {
                  <div class="innerRow">
                    <label class="note">{{ 'Including VAT' | translate }}</label>
                    <div class="wrapperS2">
                      @if (getAutoFieldPurchaseTotal('withTax'); as valueWithTax) {
                        <span class="amountReadOnly xl gapRight" [style]="purchaseTotalWithTaxStyle">{{
                          valueWithTax | currency: '' : ''
                        }}</span>
                        <span>{{ currencySelected() }}</span>
                      }
                    </div>
                  </div>
                }
              </div>

              <!-- Tipo de pago -->
              <div class="row">
                <label>Tipo de pago <span class="required">*</span></label>
                <div class="selectWrapper size2">
                  <div class="customSelect">
                    <select formControlName="paymentType" (change)="onlyChangeValue()">
                      <option [value]="'PREPAID'">{{ 'Advance' | translate }}</option>
                      <option [value]="'EXPIRATION'">{{ 'Due' | translate }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Forma de amortización -->
              <div class="row">
                <label>Forma de amort. <span class="required">*</span></label>
                <div class="selectWrapper size2">
                  <div class="customSelect">
                    <select formControlName="paymentFormationType" (change)="onlyChangeValue()">
                      <option [value]="'LEVELED'">{{ 'Level Payment' | translate }}</option>
                      <!-- <option [value]="'DESCENDING'">{{ 'Decreasing Payment' | translate }}</option> -->
                    </select>
                  </div>
                </div>
              </div>

              <!-- Gastos de ratificación -->
              <div class="row">
                <label>Gastos de ratificación</label>
                <div class="wrapperSX flexStart">
                  <input
                    type="number"
                    id="ratificationExpensesAmount"
                    class="amount"
                    style="display: none"
                    formControlName="confirmationExpensesAmount"
                    (blur)="onlyChangeValue('ratificationExpensesAmount')"
                    (keypress)="preventInvalidCharacters($event)"
                    data-select-id="confirmationExpensesAmount"
                    dataSelectId
                  />
                  <input
                    type="text"
                    id="hidden-ratificationExpensesAmount"
                    class="amount"
                    (focus)="showAmountInput('ratificationExpensesAmount')"
                    style="display: block"
                    [value]="ctr['confirmationExpensesAmount'].value | currency: '' : ''"
                  />
                  <span>{{ currencySelected() }}</span>
                </div>
              </div>

              <!-- Factor seguro de vida -->
              <div class="row" *ngIf="isLifeInsuranceApplicable()">
                <label>Factor seguro de vida</label>
                <div class="wrapperSX flexStart">
                  <input
                    type="number"
                    id="lifeInsuranceFactor"
                    class="amount gapRight"
                    style="display: none"
                    formControlName="lifeInsuranceFactor"
                    (blur)="onlyChangeValue('lifeInsuranceFactor')"
                    (keypress)="preventInvalidCharacters($event)"
                  />
                  <input
                    type="text"
                    id="hidden-lifeInsuranceFactor"
                    class="amount gapRight"
                    (focus)="showAmountInput('lifeInsuranceFactor')"
                    style="display: block"
                    [value]="ctr['lifeInsuranceFactor'].value ?? ''"
                  />
                  <span style="color: rgba(0, 0, 0, 0.5)">(max 2)</span>
                </div>
              </div>

              <!-- Colateral adicional -->
              <div class="row" *ngIf="isNormalCreditOrCreditGlobe || isCapLoanOrRealEstate()">
                <label>Colateral adicional</label>
                <div class="wrapperSX">
                  <div class="innerWrapper">
                    <div class="selectWrapper size2 gapRight">
                      <div class="customSelect">
                        <select
                          formControlName="additionalCollateralType"
                          (change)="calculateAdditionalCollateral()"
                          data-select-id="additionalCollateralType"
                          dataSelectId
                        >
                          @for (option of additionalCollateralTypeOptions; track option) {
                            <option [value]="option.value">{{ option.display }}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <ng-container *ngIf="ctr['additionalCollateralType'].value">
                      <input
                        type="number"
                        formControlName="additionalCollateralPercentage"
                        (blur)="calculateAdditionalCollateral()"
                        class="size0 percentage textAlignRight gapRight"
                        (keypress)="preventInvalidCharacters($event)"
                        appInputValidations
                      />
                      <span>%</span>
                    </ng-container>
                  </div>
                  <div class="innerWrapper">
                    <span class="amount gapRight">{{
                      ctr['additionalCollateralTotal'].value | currency: '' : ''
                    }}</span>
                    <span *ngIf="ctr['additionalCollateralType'].value">{{ currencySelected() }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Seguro -->
            <app-insurance-mobile
              *ngIf="canAddInsurance() && !isFinancialProductCapLoanOrRealEstate"
              formControlName="insurance"
              (updateInsurance)="calculateQuote('r')"
              (resetInsurance)="resetInsurance($event)"
              [idDeal]="ctr['id'].value"
              [idQuote]="idQuote"
              [isValid]="isValid()"
              [isModelValid]="isFormValidExceptInsurance()"
              [quoteType]="quoteComponentType"
              [dealerId]="insuranceService.dealerId()"
              [dealerBranchId]="insuranceService.dealerBranchId()"
              [hasManualInsurance]="hasManualInsurance"
              style="width: 100%"
            ></app-insurance-mobile>
          </div>

          <!-- Calculation results -->
          <app-calculate-diro-mobile
            [profitDeal]="ctr['profitDeal'].value"
            (updateDataDiro)="assignProfitDeal($event)"
          ></app-calculate-diro-mobile>
        </div>
        <div class="actionWrapper">
          <button class="secondary" (click)="calculateQuote('r')" [disabled]="isDisabledCalculateQuote">
            Calcular
          </button>
          <button
            class="secondary"
            (click)="calculateDiro('r')"
            [disabled]="!formGroup.valid || !hasCalculatedResult"
            *ngIf="diroService.activeDiro"
          >
            Sincronizar DIRO
          </button>

          <button
            class="secondary"
            (click)="calculateQuoteToDownloadJson()"
            *ngIf="activarBotonJson"
            [disabled]="!formGroup.valid"
          >
            Descargar JSON
          </button>

          <p class="note">Para calcular una cotización es necesario completar todos los campos requieridos.</p>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- Resultados -->
<!-- <app-quote [quote]="ctr['result'].value" [quantity]="quantityForPayments"></app-quote> -->

<!-- Pago especiales -->
<!-- <app-special-payments (calculate)="calculateQuote($event)" [specialPaymentsUpdate]="ctr['specialPayments'].value" (specialPayments)="assignSpecialPayments($event)" [idProposal]="ctr['id'].value" [idQuote]="idQuote" [isValid]="!formGroup.valid"></app-special-payments> -->

<!-- Amortizations -->

<div class="module">
  <div
    class="tabs mobile w2"
    [ngClass]="{
      w4: isActiveBrokerCatalog && isInsuranceCalculated && isAvailableInsurancePayments,
      w3: isActiveBrokerCatalog && isInsuranceCalculated && !isAvailableInsurancePayments,
      w2: !isActiveBrokerCatalog || !isInsuranceCalculated,
    }"
  >
    <a (click)="selectSection(1)" [ngClass]="{ active: showSection == 1 }">Amortizaciones ({{ currency }})</a>
    <a (click)="selectSection(2)" [ngClass]="{ active: showSection == 2 }">Períodos de gracia y pagos especiales</a>
    @if (isActiveBrokerCatalog && isInsuranceCalculated) {
      <a (click)="selectSection(3)" [ngClass]="{ active: showSection == 3 }">Seguro</a>
    }
    @if (isActiveBrokerCatalog && isAvailableInsurancePayments) {
      <a (click)="selectSection(4)" [ngClass]="{ active: showSection == 4 }">Amortizaciones seguro ({{ currency }})</a>
    }
  </div>
  <div>
    @if (showSection == 1) {
      <app-payments-mobile
        [payments]="ctr['payments'].value"
        [specialPayments]="ctr['specialPayments'].value"
        [grace]="ctr['grace'].value"
        [irregularPayments]="ctr['irregularPayments'].value"
        [quantity]="quantityForPayments"
        [currency]="currency"
        [idDeal]="ctr['id'].value"
        [idQuote]="idQuote"
        (updateGrace)="updateGrace($event)"
        (updateSpecialPayments)="updateSpecialPayments($event)"
        (updateIrregularPayments)="updateIrregularPayments($event)"
        [quoteType]="this.quoteType"
        [financialAmount]="ctr['financialAmount'].value"
        [tipoProductoFinanciero]="formGroup.get('financialProductType')?.value ?? null"
        [isCalculateDisable]="isDisableEditPayments"
      >
      </app-payments-mobile>
    } @else if (showSection == 2) {
      <open-list-special-payments-grace-period-mobile
        [payments]="ctr['payments'].value"
        [specialPayments]="ctr['specialPayments'].value"
        [grace]="ctr['grace'].value"
        [irregularPayments]="ctr['irregularPayments'].value"
        [idQuote]="idQuote"
        [idDeal]="ctr['id'].value"
        [financialProduct]="ctr['financialProductType'].value"
        [financialAmount]="ctr['financialAmount'].value"
        (updateGrace)="updateGrace($event)"
        (updateSpecialPayments)="updateSpecialPayments($event)"
        (updateIrregularPayments)="updateIrregularPayments($event)"
        [quoteType]="this.quoteType"
        [isCalculateDisable]="isDisableEditPayments"
      />
    } @else if (showSection == 3) {
      <app-insurance-list-payments-mobile [quantity]="ctr['quantity'].value" [coverage]="formInsurance" />
    } @else if (showSection == 4) {
      <app-insurance-amortizations-mobile
        [payments]="insurancePayments"
        [quantity]="ctr['quantity'].value"
        [currency]="currency"
        [readOnly]="true"
        [tipoProductoFinanciero]="ctr['financialProductType'].value"
        [grace]="ctr['grace'].value"
      ></app-insurance-amortizations-mobile>
    }
  </div>
</div>

<div class="quotationActions">
  <button (click)="cancel()" class="secondary">Volver</button>
  <button (click)="save()" [disabled]="!formGroup.valid" class="primary">Guardar</button>
  <p class="note">Para Guardar un cotización es necesario sincronizar los datos con DIRO.</p>
</div>
<ng-template #modalTemplate>
  <div class="modal" style="max-width: 620px">
    <a class="close">Cerrar</a>
    <h1>Eliminar seguros</h1>
    <p>
      Esta editando datos sensibles, si continúa con los cambios todos los seguros generados anteriormente seran
      eliminados.
    </p>
    <div class="modalActions index">
      <button class="secondary">Cancelar</button>
      <button (click)="deleteAllInsurance()" class="primary">Eliminar</button>
    </div>
  </div>
</ng-template>
<ng-template #modalDiroLogin>
  <app-modal-diro-login (closed)="closedDiroModal($event)" />
</ng-template>
<ng-template #modalStatus>
  <app-modal-status [data]="diroService.getStatusModalData()" />
</ng-template>
<ng-template #modalConfirmation>
  <app-template-confirmation
    [title]="confirmationData().title"
    [subtitle]="confirmationData().subtitle"
    [btn1]="confirmationData().btn1"
    [btn2]="confirmationData().btn2"
    (closeModal)="closeConfirmationModal()"
    (actionBtn2)="confirmationByType()"
  ></app-template-confirmation>
</ng-template>
